<template>
  <v-container fluid>
    <v-data-table :headers="headers" class="elevation-1" :items="vendedores" :loading="loading">
      <template v-slot:top>
        <v-toolbar flat>
          <datatable-filters :filters="filters" v-model="filtrosAtivos"></datatable-filters>
          <v-divider vertical inset class="mx-4" />
          <v-spacer />
          <v-btn
            v-if="perms.includes('vendedor.criar_vendedor')"
            depressed
            color="accent"
            :to="{ name: 'vendedor-formulario' }"
          >
            <v-icon class="mdi mdi-account-plus mr-2" />Novo Cadastro
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.id_funcionario="{item}">
        <span v-if="!item.id_funcionario">Externo</span>
        <template v-else>
          <span class="caption">Funcionário</span>
          <br />
          <b>{{item.matricula}}</b>
        </template>
      </template>
      <template v-slot:item.telefone="{ item }">{{telefoneMask(item.telefone)}}</template>
      <template v-slot:item.usuario="{item}">
        <span v-if="!item.id_usuario">-</span>
        <template v-else>
          <span class="caption">{{item.usuario.login}}</span>
          <br />
          <b>{{item.usuario.nome}}</b>
        </template>
      </template>
      <template v-slot:item.actions="{ item }">
        <lista-documentos-dialog
          :title="`Documentos de ${item.nome}`"
          :id-proprietario="item.id_funcionario !== null ? item.id_funcionario : item.id"
          :url-base="item.id_funcionario !== null ? 'funcionarios' : 'vendedores'"
        />
        <v-btn
          v-if="perms.includes('vendedor.criar_vendedor')"
          icon
          small
          text
          @click="editar(item.id)"
        >
          <v-icon class="mdi mdi-pencil" small />
        </v-btn>
        <dialog-confirm
          v-if="perms.includes('vendedor.excluir_vendedor')"
          titulo="Deletar vendedor"
          texto="Confirma a exclusão?"
          @confirmar="deletar(item.id)"
        >
          <v-btn icon small text>
            <v-icon class="mdi mdi-delete" small />
          </v-btn>
        </dialog-confirm>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import DatatableFilters from "../components/DatatableFilters";
import DialogConfirm from "../components/DialogConfirm";
import ListaDocumentosDialog from "../components/documentos/ListaDocumentosDialog";
import { build } from "../lib/masks";
export default {
  components: { DatatableFilters, DialogConfirm, ListaDocumentosDialog },
  data() {
    return {
      headers: [
        { text: "#", value: "id" },
        { text: "Tipo", value: "id_funcionario", align: "center" },
        { text: "Nome", value: "nome" },
        { text: "E-mail", value: "email" },
        { text: "Telefone", value: "telefone" },
        { text: "Usuário associado", value: "usuario", sortable: false },
        { text: "Ações", value: "actions", sortable: false, align: "center" },
      ],
      filters: [
        {
          name: "matricula",
          label: "Matrícula de funcionário",
          type: "number",
          defaultValue: "",
        },
        {
          name: "nome",
          label: "Nome",
          type: "text",
          defaultValue: "",
        },
        {
          name: "id_usuario",
          label: "Usuário associado",
          type: "select",
          options: [],
        },
      ],
      filtrosAtivos: JSON.parse(
        localStorage.getItem("filtros.vendedores") || "{}"
      ),
      loading: true,
    };
  },
  computed: mapState({
    vendedores: (state) => state.vendedor.vendedores,
    perms: (state) => state.usuarios.usuarioAtivo.permissoes,
  }),
  methods: {
    async deletar(id) {
      this.loading = true;
      await this.$store.dispatch("vendedor/deletar", id);
      this.listar();
    },
    editar(id) {
      this.$router.replace({
        name: "vendedor-formulario-editar",
        params: { id },
      });
    },
    async listar() {
      this.loading = true;
      try {
        await this.$store.dispatch("vendedor/listar", {
          filtros: this.filtrosAtivos,
        });
      } catch (err) {
        console.log(err);
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível carregar a lista de vendedores",
        });
      }
      this.loading = false;
    },
    telefoneMask(val) {
      return build.phone(val);
    },
  },
  watch: {
    filtrosAtivos(val) {
      localStorage.setItem("filtros.vendedores", JSON.stringify(val));
      this.listar();
    },
  },
  mounted() {
    this.$store.commit("ui/changeToolbar", {
      title: "Cadastro de vendedores",
    });
    this.listar();

    this.$store.dispatch("usuarios/listar", {}).then((response) => {
      this.filters.find(
        (f) => f.name === "id_usuario"
      ).options = response.data.map((v) => ({
        text: v.nome,
        value: v.id,
      }));
    });
  },
};
</script>
